import { createFileRoute } from '@tanstack/react-router'
import { AuditorAuditEvidenceRoutePage } from '@/components/auditor-center/AuditorAuditEvidenceRoutePage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/',
)({
  staticData: { pageHeader: { title: 'Evidence', customHeader: true, pad: false } },
  component: AuditorAuditEvidenceRoutePage,
})
